/* eslint no-undef: 0 */
/* eslint arrow-parens: 0 */
import React from 'react';
import { enquireScreen } from 'enquire-js';

import Banner3 from './Banner3';
import Content0 from './Content0';
import Content1 from './Content1';


import { Banner32DataSource, Content00DataSource,Content10DataSource } from './data.source';
import './less/antMotionStyle.less';

    

let isMobile;
enquireScreen((b) => {
  isMobile = b;
});


// 行业动态 
var hangYeList = window.apiObj.hangYeList

// 解决方案
var jieJueList = window.apiObj.jieJueList

const { location = {} } = typeof window !== 'undefined' ? window : {};

 class Detail extends React.Component {
  constructor(props) {
    
    var result = new URLSearchParams(props.location.search);
    var hangYeName = result.get('name');
    var type = result.get('type');
    var page = result.get('page');
    var title = result.get('title');
    if (title.indexOf('"')!=-1) {
      title = title.replace('"','')
    }
    if (hangYeName.indexOf('"')!=-1) {
      hangYeName = hangYeName.replace('"','')
    }
    var navTitle = result.get('navTitle')||result.get('"navTitle')
      super(props);
        this.state = {
          isMobile,
          title:title,
          type:type,
          page:page,
          detail:{},
          navTitle:navTitle||'行业动态',
          show: !location.port, // 如果不是 dva 2.0 请删除
        };
      Banner32DataSource.textWrapper.children[1].children = hangYeName
      Banner32DataSource.textWrapper.children[3].children = navTitle||'行业动态'
      Content10DataSource.titleWrapper.children[1].children = title 
    }

  componentDidMount() {
    console.log('hangYeList-detail',this.state.title,this.state.type,hangYeList);
    // ----------------------------------------
    // 行业动态详情数据
    if (this.state.type=='news') {
      hangYeList.forEach(element => {
        if (element.title==this.state.title) {
          console.log(element);
          // 样式 build 时间在 200-300ms 之间;
          setTimeout(() => {
            this.setState({
              detail:element
            });
            console.log('detail-item',this.state.detail);
          }, 500);
        }
      });  
    }
    // ------------------------------------------
    // 解决方案 详情数据
    
    if (this.state.type=='solution') {
      jieJueList.forEach(element => {
        if (element.title==this.state.title) {
          console.log(element);
          // 样式 build 时间在 200-300ms 之间;
          setTimeout(() => {
            this.setState({
              detail:element
            });
            console.log('detail-item',this.state.detail);
          }, 500);
        }
      });  
    }
    // -------------------------------------------

   
    
    // 适配手机屏幕;
    enquireScreen((b) => {
      this.setState({ isMobile: !!b });
    });
    // dva 2.0 样式在组件渲染之后动态加载，导致滚动组件不生效；线上不影响；
    /* 如果不是 dva 2.0 请删除 start */
    if (location.port) {
      // 样式 build 时间在 200-300ms 之间;
      setTimeout(() => {
        this.setState({
          show: true,
        });
      }, 500);
    }
    /* 如果不是 dva 2.0 请删除 end */
  }

  render() {
    const children = [
      <Banner3
        id="Banner3_2"
        key="Banner3_2"
        dataSource={Banner32DataSource}
        isMobile={this.state.isMobile}
      />,
      <Content0
        id="Content0_0"
        key="Content0_0"
        routerPage={this.state.page}
        navTitle={this.state.navTitle}
        dataSource={Content00DataSource}
        isMobile={this.state.isMobile}
      />,
      <Content1
        id="Content1_0"
        key="Content1_0"
        style={{backgroundColor: '#fff',margin: '20px auto 0px auto',  width: 'calc(100% - 30%)'}}
        article={''}
        detail = {this.state.detail}
        dataSource={Content10DataSource}
        isMobile={this.state.isMobile}
      />
    ];
    return (
      <div
        className="templates-wrapper"
        style={{backgroundColor: '#f1f1f1',paddingBottom:'20px'}}
        ref={(d) => {
          this.dom = d;
        }}
      >
        {/* 如果不是 dva 2.0 替换成 {children} start */}
        {this.state.show && children}
        {/* 如果不是 dva 2.0 替换成 {children} end */}
      </div>
    );
  }
}


export default Detail